import { isPositionBottom, isPositionHorizontal, isPositionLeft, isPositionRight, isPositionTop, isPositionVertical, POPOVER_CARET_SIZE, } from './PopoverUtil';
const BORDER_WIDTH = 1;
export const calculateCaretPositionCSSProperties = ({ position, trigger, content, }) => {
    const result = {
        '--caret-top-position': 'unset',
        '--caret-left-position': 'unset',
        '--caret-shadow-top-position': 'unset',
        '--caret-shadow-left-position': 'unset',
    };
    let xPos = 0;
    let yPos = 0;
    let xShadowPos = 0;
    let yShadowPos = 0;
    if (isPositionVertical(position)) {
        xPos = trigger.x + Math.floor(trigger.width / 2 - POPOVER_CARET_SIZE / 2);
        xShadowPos = xPos - BORDER_WIDTH;
        if (isPositionTop(position)) {
            yPos = content.y + content.height - BORDER_WIDTH;
            yShadowPos = yPos;
        }
        if (isPositionBottom(position)) {
            yPos = content.y - POPOVER_CARET_SIZE + BORDER_WIDTH;
            yShadowPos = yPos - BORDER_WIDTH * 2;
        }
    }
    if (isPositionHorizontal(position)) {
        yPos = trigger.y + Math.floor(trigger.height / 2 - POPOVER_CARET_SIZE / 2);
        yShadowPos = yPos - BORDER_WIDTH;
        if (isPositionLeft(position)) {
            xPos = content.x + content.width - BORDER_WIDTH;
            xShadowPos = xPos;
        }
        if (isPositionRight(position)) {
            xPos = content.x - POPOVER_CARET_SIZE + BORDER_WIDTH;
            xShadowPos = xPos - BORDER_WIDTH * 2;
        }
    }
    result['--caret-top-position'] = `${yPos}px`;
    result['--caret-left-position'] = `${xPos}px`;
    result['--caret-shadow-top-position'] = `${yShadowPos}px`;
    result['--caret-shadow-left-position'] = `${xShadowPos}px`;
    return result;
};
